export default "__VITE_ASSET__CuivLpy___"